import React from 'react';
import { Clock, User, MapPin } from 'lucide-react';

/**
 * Barra fija al pie, en el teléfono, con lo que el cliente lleva elegido.
 *
 * La página de reserva es larga y el único hilo conductor era un scrollIntoView
 * programático: si el cliente subía a revisar algo, perdía de vista qué había
 * elegido y cuánto salía. Esta barra lo deja siempre visible.
 *
 * Solo en móvil (abajo de lg): en escritorio las secciones entran juntas en
 * pantalla y una barra fija sería ruido.
 */
export default function ResumenReserva({ servicio, profesional, recurso }) {
  if (!servicio) return null;

  const detalles = [
    { icono: Clock, texto: `${servicio.duration} min` },
    profesional && {
      icono: User,
      texto: profesional.isAnyStaff ? 'Sin preferencia' : profesional.name,
    },
    recurso && { icono: MapPin, texto: recurso.name },
  ].filter(Boolean);

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 border-t border-neutral-200 bg-white/95 px-4 py-3 backdrop-blur lg:hidden"
      style={{ paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom))' }}
      role="status"
      aria-live="polite"
    >
      <div className="flex items-center justify-between gap-4">
        <div className="min-w-0">
          <p className="truncate font-semibold text-neutral-900">{servicio.name}</p>
          <div className="mt-0.5 flex flex-wrap items-center gap-x-3 gap-y-0.5">
            {detalles.map(({ icono: Icono, texto }) => (
              <span
                key={texto}
                className="inline-flex items-center gap-1 text-xs text-neutral-500"
              >
                <Icono className="h-3 w-3 shrink-0" />
                <span className="truncate">{texto}</span>
              </span>
            ))}
          </div>
        </div>
        <p className="shrink-0 text-lg font-bold text-primary">
          {servicio.enableDynamicPricing && (
            <span className="mr-1 text-xs font-normal text-neutral-500">Desde</span>
          )}
          ${servicio.price?.toLocaleString('es-AR') || '—'}
        </p>
      </div>
    </div>
  );
}
